module.exports = __webpack_public_path__ + "static/media/plumbing-585658_640.73623bb4.png";